//  This is a generated file, do not edit it directly
import SvgIcon from '@mui/material/SvgIcon';
import type { TpBaseSvgIconProps } from '../types/muiSvgIcon';
import { SvgSquareTick } from '../icons/SquareTick';

export function SquareTickIcon(props: TpBaseSvgIconProps): React.ReactElement {
  return (
    <SvgIcon {...props} component={SvgSquareTick} data-qa="SquareTickIcon">
      <svg />
    </SvgIcon>
  );
}
